import { CluLiveMark } from '@/components/ui/clu-ponder.component';
import { CluBird } from '@/components/ui/copilot-icon.component';
import { useCluSaluteOnOpen } from '@/hooks/use-clu-salute.hook';
import { cn } from '@/lib/utils';
import { useAgentMarkKeys } from './agent-mark-order.store';
import { markColours } from './agent-mark.util';

/**
 * The agent's mark: Clu's bird in the colour stored on the agent. Used in
 * the workspace header and switcher, the guided screen, the settings, the
 * library cards, the sidebar and the agent's replies. With `waveChance`, it
 * may wave in its colours when the agent opens.
 */
export function AgentMark({
  agentId,
  size,
  className,
  waveChance = 0,
  waveCount,
  pondering = false,
}: {
  agentId: string;
  size: number;
  className?: string;
  waveChance?: number;
  /** Each increase waves the mark. */
  waveCount?: number;
  /** The agent is working: the mark ponders until it's done. */
  pondering?: boolean;
}) {
  const colours = markColours(agentId, useAgentMarkKeys());
  const salute = useCluSaluteOnOpen(waveChance, agentId);
  const animated = waveChance > 0 || waveCount !== undefined;
  return (
    <span
      aria-hidden
      data-agent-mark
      className={cn('inline-flex shrink-0', className)}
      style={{ width: size, height: size }}
    >
      {animated || pondering ? (
        <CluLiveMark
          thinking={pondering}
          colours={colours}
          waveCount={salute.waveCount + (waveCount ?? 0)}
          className='h-full w-full'
        />
      ) : (
        <CluBird colours={colours} className='h-full w-full' />
      )}
    </span>
  );
}
